import { render, staticRenderFns } from "./right-side.vue?vue&type=template&id=180a363e&scoped=true&"
import script from "./right-side.vue?vue&type=script&lang=js&"
export * from "./right-side.vue?vue&type=script&lang=js&"
import style0 from "./right-side.vue?vue&type=style&index=0&id=180a363e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180a363e",
  null
  
)

export default component.exports